module.exports = __webpack_public_path__ + "img/TBWTTNL_app_feather.1032865a.jpg";